/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IDoctor } from 'app/shared/model/doctor.model';
import { ITumor } from 'app/shared/model/tumor.model';

export interface ITumorStaging {
  id?: string;
  stage?: string;
  stagingDate?: number;
  displayId?: string | null;
  algorithm?: string;
  version?: string;
  title?: string | null;
  subtitle?: string | null;
  notes?: string | null;
  stagingInput?: string | null;
  stagingOutcome?: string | null;
  active?: boolean;
  cursor?: number;
  lastUpdated?: number;
  microSec?: number;
  timestampEntry?: number;
  recordedBy?: IDoctor | null;
  tumor?: ITumor | null;
}

export const defaultValue: Readonly<ITumorStaging> = {
  active: false,
};
